<template>
  <div class="flex flex-col overflow-x-auto">
    <div class="overflow-x-auto">
      <div class="inline-block w-full py-2 align-middle">
        <h1
          class="py-2 text-lg font-medium text-ontick-steel-900 dark:text-gray-300"
        >
          Posições
        </h1>

        <div
          class="overflow-hidden border-b border-ontick-steel-300 shadow dark:border-ontick-steel-600 sm:rounded-lg"
        >
          <table
            class="min-w-full divide-y divide-ontick-steel-300 dark:divide-ontick-steel-600"
          >
            <thead class="bg-ontick-steel-100 dark:bg-ontick-steel-600">
              <tr>
                <th
                  v-for="(item, index) in header"
                  :key="index"
                  scope="col"
                  class="title_th"
                >
                  <button
                    class="flex h-full w-full items-center justify-center space-x-1 text-center"
                    @click="sort(item.key)"
                  >
                    <span v-if="item.key === sortKey">
                      {{ sortIcon }}
                    </span>
                    <p>
                      {{ item.label }}
                    </p>
                  </button>
                </th>
              </tr>
            </thead>
            <transition-group
              v-on:enter="enter"
              v-on:leave="leave"
              v-bind:css="true"
              appear
              tag="tbody"
              class="divide-y divide-ontick-steel-300 dark:divide-ontick-steel-600"
            >
              <tr
                class="bg-gray-50 dark:bg-ontick-graphite-500"
                v-for="(item, index) in sortedData"
                :key="index"
              >
                <td class="td-items">
                  {{ item.position_symbol }}
                </td>

                <td class="td-items">
                  {{ item.strategy_name }}
                </td>
                <td class="td-items">
                  {{ item.position_time | moment("DD/MM/YYYY HH:mm:ss:SSS") }}
                </td>
                <td class="td-items">
                  {{ item.position_type }}
                </td>
                <td class="td-items">
                  {{ item.position_volume }}
                </td>

                <td class="td-items">
                  {{ item.position_price }}
                </td>

                <td class="td-items">
                  {{ item.position_sl }}
                </td>
                <td class="td-items">
                  {{ item.position_tp }}
                </td>
                <td class="td-items">
                  <span
                    class="z-0"
                    :class="
                      item.position_profit == 0
                        ? 'text-ontick-steel-900 dark:text-gray-300'
                        : item.position_profit > 0
                        ? 'text-ontick-green-700 dark:text-ontick-green-500'
                        : 'text-ontick-red-600 dark:text-ontick-red-500'
                    "
                  >
                    {{ item.position_profit | currency }}
                  </span>
                </td>
                <td class="td-items">
                  {{ item.position_comment }}
                </td>
              </tr>
              <tr
                key="final"
                v-if="data.investments.length == 0 && !placeholder"
              >
                <td colspan="10">
                  <h2
                    class="py-20 text-center text-2xl font-medium text-ontick-steel-900 dark:text-gray-300"
                  >
                    Nenhuma posição gerada
                  </h2>
                </td>
              </tr>

              <tr
                key="placeholder"
                v-if="data.investments.length == 0 && placeholder"
              >
                <td colspan="10">
                  <placeholder-card-component :qtd="3" />
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlaceholderCardComponent from "../../../../shared/components/placeholder/placeholder-card.component.vue";
export default {
  components: {
    PlaceholderCardComponent,
  },

  props: {
    data: {
      type: Object,
    },
    placeholder: {
      type: Boolean,
    },
  },

  data() {
    return {
      header: [
        { label: "Ativo", key: "position_symbol" },
        { label: "Estratégia", key: "strategy_name" },
        { label: "Horário", key: "position_time" },
        { label: "Tipo", key: "position_type" },
        { label: "Volume", key: "position_volume" },
        { label: "Preço", key: "position_price" },
        { label: "SL", key: "position_sl" },
        { label: "TP", key: "position_tp" },
        { label: "Resultado", key: "position_profit" },
        { label: "Comentário", key: "position_comment" },
      ],
      sortDirection: "",
      sortKey: "",
    };
  },

  computed: {
    sortIcon() {
      const directions = {
        asc: "▲",
        desc: "▼",
      };
      return directions[this.sortDirection] || "";
    },
    presortedData() {
      return this.data.investments.sort((a, b) => {
        if (a.position_time > b.position_time) {
          return -1;
        } else if (a.position_time < b.position_time) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    sortedData() {
      switch (this.sortDirection) {
        case "asc":
          return this.presortedData.sort((a, b) => {
            if (a[this.sortKey] < b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] > b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        case "desc":
          return this.presortedData.sort((a, b) => {
            if (a[this.sortKey] > b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] < b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        default:
          return this.presortedData;
      }
    },
  },

  methods: {
    sort(key) {
      if (key) {
        if (this.sortKey === key) {
          this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
        } else {
          this.sortDirection = "asc";
        }
        this.sortKey = key;
      }
    },
    enter(el, done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      tl.set(el, {
        x: window.innerWidth * 0.5,
        scale: 0.9,
        transformOrigin: "50% 50%",
      });

      tl.to(el, 0.3, {
        x: 0,
        ease: Power4.easeOut,
      });

      tl.to(el, 0.3, {
        scale: 1,
        ease: Power4.easeOut,
      });
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.3,
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.title_th {
  @apply px-3 py-2 text-center text-sm font-medium text-ontick-steel-900 dark:text-gray-300;
}
.td-items {
  @apply whitespace-nowrap px-3 py-3 text-center text-xs text-ontick-steel-900 dark:text-gray-300;
}
</style>
